// extracted by mini-css-extract-plugin
export var actions = "_1w-0";
export var actionsContainer = "_1w-7";
export var border = "_1w-1";
export var childFullHeight = "_1w-f";
export var collapse = "_1w-2";
export var content = "_1w-a";
export var contentChild = "_1w-e";
export var fullscreen = "_1w-c";
export var hasLeftRadius = "_1w-k";
export var headerContainer = "_1w-3";
export var headerRow = "_1w-5";
export var hidePadding = "_1w-b";
export var navCollapsedGap = "_1w-l";
export var noScrollX = "_1w-m";
export var noScrollY = "_1w-n";
export var noTopPadding = "_1w-i";
export var optOutTopPadding = "_1w-d";
export var pageMain = "_1w-j";
export var pageOuter = "_1w-g";
export var pagePadding = "_1w-8";
export var pageScroll = "_1w-9";
export var profile = "_1w-o";
export var profileContainer = "_1w-p";
export var profileImage = "_1w-q";
export var profileMain = "_1w-r";
export var profileSubtitle = "_1w-t";
export var profileTitle = "_1w-s";
export var showLeftPadding = "_1w-h";
export var tabsPortalSlot = "_1w-6";
export var tabsWrapper = "_1w-4";
export var title = "_1w-u";